module.exports = __webpack_public_path__ + "media/stylesheets/resident/images/ico-notice-4b2a8b473ad7fc367d6c3e933441165b.svg";